import { Skeleton } from "@mui/material";
import React from "react";
import useTitanApp from "../../hooks/useTitanApp";

export default function LoadingSkeletonComponent() {
  const { appState } = useTitanApp();
  const { darkMode } = appState || {};
  return (
    <div className="skeleton-container">
      <div className="skeleton-item">
        <Skeleton
          sx={{ bgcolor: darkMode ? "grey.800" : "" }}
          height={45}
          width={"100%"}
          animation="wave"
          variant="rounded"
        />
          </div>
      <div className="skeleton-item">
        <Skeleton
          sx={{ bgcolor: darkMode ? "grey.800" : "" }}
          height={45}
          width={"100%"}
          animation="wave"
          variant="rounded"
        />
      </div>
      <div className="skeleton-item">
        <Skeleton
          sx={{ bgcolor: darkMode ? "grey.800" : "" }}
          height={45}
          width={"100%"}
          animation="wave"
          variant="rounded"
        />
      </div>
    </div>
  );
}
